import { PropsWithChildren } from 'react';

import { FormErrorFocus } from 'components';
import { FormSubmit } from 'libs/form';
import { useTranslation } from 'libs/i18n';
import { DeepPartial } from 'types/deepPartial';

import { Form, getSchema, OrderFormType } from '../../forms/orderForm';
import { useOrderContext } from '../../providers/OrderProvider';

export interface OrderViewProps {
  initialValues: DeepPartial<OrderFormType>;
  onSubmit: FormSubmit<OrderFormType>;
}

export const OrderForm = ({
  initialValues,
  onSubmit,
  children,
}: PropsWithChildren<OrderViewProps>) => {
  const { orderType, disabledDates, minEndDate, order } = useOrderContext();
  const { t } = useTranslation();

  const schema = getSchema(t, {
    orderType,
    disabledDates,
    minEndDate,
    mode: 'edit',
    orderStatus: order?.status,
  });

  return (
    <Form
      hidePlaceholderIfReadonly
      initialReadOnly
      initialShowCopyButton
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      <FormErrorFocus />
      {children}
    </Form>
  );
};
